const stations = {
  bindings: {
  },
  templateUrl: '/modules/pis-tool/stations/stations.html',
  controller: 'StationsController',
};

angular
  .module('pis-tool.module')
  .component('stations', stations)
  .config(function($stateProvider) {
      $stateProvider.state('pis.workspaces.stations', {
          url: '/stations',
          redirectTo: 'pis.workspaces.stations.list',
          views: {
              'pisview@pis': 'stations',
          },
      });
  });
